import React from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import Step3PreviewGenerate from "./Step3PreviewGenerate";
import NavBar from "./Navbar";
import TopNavBar from "./TopNavbar";
import { Button } from "./ui/button";
import { Download } from "lucide-react";
import { PERMISSIONS } from "../utils/rbac";
import {
  deniedActionClass,
  usePermissionGuard,
} from "../hooks/usePermissionGuard";

export default function PreviewInvoiceNew() {
  const location = useLocation();
  const navigate = useNavigate();
  const step3PdfGenerateRef = React.useRef(null);
  const data = location.state || {};
  const { guardAction, PermissionDialog, isAllowed } = usePermissionGuard();
  const canPdf = isAllowed(PERMISSIONS.GENERATE_PDF);

  if (!data.property && !data.invoiceNumber) {
    return (
      <div className="admin-panel-parent-container min-h-screen flex flex-col items-center justify-center bg-gray-50">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-800">
            No Preview Data Found
          </h2>
          <p className="text-gray-600 mt-2">
            Please go back and generate the preview again.
          </p>
          <Button
            className="mt-6"
            onClick={() => navigate("/generateInvoiceNew")}
          >
            Go Back
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-panel-parent-container invoices-page-wrapper">
      <NavBar />
      <TopNavBar />
      <PermissionDialog />

      <div className="invoices-page-wrapper ml-[15%] mt-[66px] px-4 sm:px-6 lg:px-8 py-12 sm:py-6 bg-gray-100 min-h-[calc(100vh-66px)]">
        {/* Breadcrumbs */}
        <div className="text-sm mb-4 flex flex-wrap items-center gap-y-1">
          <Link className="text-primary hover:underline" to="/dashboard">
            Dashboard
          </Link>
          <span className="text-primary mx-2">&gt;</span>
          <Link className="text-primary hover:underline" to="/invoices">
            Invoices
          </Link>
          <span className="text-primary mx-2">&gt;</span>
          <Link
            className="text-primary hover:underline"
            to="/generateInvoiceNew"
          >
            Generate Invoice
          </Link>
          <span className="text-primary mx-2">&gt;</span>
          <span className="text-primary font-bold">Preview</span>
        </div>

        {/* Page Header */}
        <div className="flex items-center justify-between mb-6 pt-1">
          <div>
            <span className="text-2xl sm:text-3xl font-black text-[#131614]">
              Invoice Preview
            </span>
            <p className="text-sm text-[#64748B] mt-1">
              Review your document before downloading or sending
            </p>
          </div>
          <Button
            variant="default"
            className={deniedActionClass(canPdf)}
            onClick={() => {
              guardAction(PERMISSIONS.GENERATE_PDF, "download PDF", () => {
                if (typeof step3PdfGenerateRef.current === "function") {
                  step3PdfGenerateRef.current();
                }
              });
            }}
          >
            <Download className="h-4 w-4 mr-2" />
            Download PDF
          </Button>
        </div>

        <div className="max-w-full mx-auto">
          <Step3PreviewGenerate
            {...data}
            isPreviewMode={true}
            refPdfGenerate={(fn) => {
              step3PdfGenerateRef.current = fn;
            }}
          />
        </div>
      </div>
    </div>
  );
}
